import _ from 'lodash'
import { computed, ComputedRef, Ref, ref } from 'vue'
import { useAuthStore } from '@/plugins/w/auth/store/auth.store'
import { useQuery } from '@tanstack/vue-query'
import { STALE_TIME } from '../'

export const PAGINATION_DEFAULTS = {
	current_page: 1,
	per_page: 10,
	last_page: 10
}

const defaultQueryBuilder = (pagination: Pagination, filters: Object) => {
	return _.merge({}, pagination, filters)
}


export const createApiHook = (fetchFunction: Function, queryKey: any, queryBuilder: Function = defaultQueryBuilder, options: { enabled: (filters: any) => ComputedRef<boolean> } = { enabled: () => computed(() => true) }) => {
	return (pagination: Ref<Pagination> = ref({ ...PAGINATION_DEFAULTS }), filters: Ref<any> = ref({})) => {
		const authStore = useAuthStore()

		const access = computed(() => ({ accessId: authStore.getCurrentAccess?.id }))
		const query = computed(() => queryBuilder(pagination.value, filters.value))
		const nextPage = computed(() => query.value.offset ?  {offset: query.value.offset + query.value.limit} : {page: pagination.value.current_page + 1})

		const QUERY_FILTERS = computed(() => _.merge({}, access.value, query.value))
		const NEXT_QUERY_FILTERS = computed(() => _.merge({}, access.value, nextPage.value, query.value))
		// const NEXT_QUERY_FILTERS = computed(() => _.merge(query.value, access, { page: pagination.value.current_page + 1 }))

		const PREFETCH_QUERY = computed(() => ({ queryKey: [queryKey, QUERY_FILTERS], queryFn: () => fetchFunction(pagination.value, filters.value), staleTime: STALE_TIME, retry: false }))
		const PREFETCH_NEXT_QUERY = computed(() => ({ queryKey: [queryKey, NEXT_QUERY_FILTERS], queryFn: () => fetchFunction({...pagination.value, current_page: pagination.value.current_page + 1}, filters.value), staleTime: STALE_TIME, retry: false }))

		const GET_QUERY = () => {
			return useQuery({
				queryKey: [queryKey, QUERY_FILTERS],
				queryFn: () => fetchFunction(pagination.value, filters.value),
				staleTime: STALE_TIME,
				retry: false,
				enabled: options.enabled(filters.value)
			})
		}

		return {
			GET_QUERY,
			PREFETCH_QUERY,
			PREFETCH_NEXT_QUERY
		}
	}
}

